import * as React from 'react';
import propz from 'propz';
import BPromise from 'bluebird';
import { parse } from 'query-string';
import { History, Location } from 'history';
import { Component } from 'react';
import moment from 'moment';
import { getFullName } from 'Src/helpers/autocomplete/autocomplete';
import { AppUser } from 'Src/views/App/App';
import { Basket } from 'Src/models/basket';
import { EventInvitationMessage, MessageField } from 'Src/models/message';
import { FormSubmission } from 'Src/types/formSchema';
import { Child } from 'Src/models/child';
import { Loader } from 'Src/components/Loader/Loader';
import { ClubBookingCard } from 'Src/components/ClubBookingCard/ClubBookingCard';
import { Button } from 'Src/components/Button/Button';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { Map } from 'Src/components/Map/Map';
import { ClubInvitationForm } from 'Src/components/ClubInvitationForm/ClubInvitationForm';
import { ClubBookingDeatils } from '../ClubBookingDetails/ClubBookingDetails';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { ParentFilterBar } from 'Src/components/ParentFilterBar/ParentFilterBar';
import { AppliedTextFilterChip } from 'Src/components/AppliedTextFilterChip/AppliedTextFilterChip';
import { ItemsBar } from 'Src/views/GenericView/ParentView/Calendar/ItemsBar';
import { WEEK_DAYS_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/date';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, CARD_LIMIT } from 'Src/consts/table';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION,
  getSearchFilter,
  getSearchOrder,
  getOrder
} from 'Src/helpers/table/table';
import {
  getParentInboxMessages,
  getParentInboxMessagesCount,
  rejectParentClubInvitation,
  acceptParentClubInvitation,
  setMessageWaitingStatus
} from 'Src/helpers/service/parent/messagesTable';
import { getChildren } from 'Src/helpers/service/parent/children';
import { getBasket, addOrderToBasket } from 'Src/helpers/service/parent/basket';
import { INVITE_TYPE } from 'Src/consts/invite';
import { ParentPageHeader } from '../../components/ParentPageHeader';
import '../../components/ParentLists.scss';
import {
  ClubSectionCounts,
  clubSectionTabs,
  getParentClubSectionCounts,
  hasClubSectionContent
} from 'Src/helpers/club/clubSectionCounts';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  setNeedUpdate: () => void;
}

interface State {
  items: EventInvitationMessage[];
  selectedItem: EventInvitationMessage | undefined;
  basket: Basket | undefined;
  total: number;
  currentPage: number;
  filters: any;
  sortFieldName: string;
  sortDirection: string;
  isFiltersOpen: boolean;
  isLoading: boolean;
  children: Child[];
  basePath: string;
  isViewMapModalOpen: boolean;
  mapPoint?: { type: 'Point'; coordinates: [number, number] } | null;
  mapLabel?: string;
  isDeclineModalOpen: boolean;
  isAcceptModalOpen: boolean;
  isAddToBasketProceedModalOpen: boolean;
  isShowDetailsModalOpen: boolean;
  sectionCounts?: ClubSectionCounts;
}

const FILTER_FIELDS_ALL: ColumnDefinition[] = [
  { text: 'Children', field: 'childIdList', type: FILTER_TYPE.MULTISELECT, accessor: [''], isSort: false },
  { text: 'Club name', field: 'clubName', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Sport', field: 'sport', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Invitation date', field: 'createdAt', type: FILTER_TYPE.DATE_INTERVAL, accessor: [''], isSort: true },
  {
    text: 'Club start date',
    field: 'schedule.startDate',
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: [''],
    isSort: false
  },
  { text: 'Days', field: 'days', type: FILTER_TYPE.MULTISELECT, accessor: [''], isSort: false }
];

const ALL_DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

export class ClubBookingsInbox extends Component<Props, State> {
  private answeredMessageIds = new Set<string>();

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItem: undefined,
      basket: undefined,
      total: 0,
      currentPage: FIRST_PAGE,
      filters: {},
      sortFieldName: '',
      sortDirection: '',
      isFiltersOpen: false,
      isLoading: false,
      basePath: '',
      children: [],
      isViewMapModalOpen: false,
      mapPoint: null,
      mapLabel: undefined,
      isDeclineModalOpen: false,
      isAcceptModalOpen: false,
      isAddToBasketProceedModalOpen: false,
      isShowDetailsModalOpen: false
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({ isLoading: true });
      this.setItems();
    }
  }

  private normalizeFiltersForQuery = (f: any) => {
    const src = { ...(f || {}) };
    const out: any = {};

    const trimOrUndef = (v?: any) => {
      if (typeof v === 'string') {
        const s = v.trim();
        return s || undefined;
      }
      if (v && typeof v === 'object') {
        const like = String((v as any).like ?? (v as any).$regex ?? '').trim();
        return like || undefined;
      }
      return undefined;
    };

    const toIso = (s?: string) => {
      if (!s) return s;
      const m1 = s.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
      const m2 = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m1) return `${m1[3]}-${m1[2]}-${m1[1]}`;
      if (m2) return s;
      return s;
    };

    const clubName = trimOrUndef(src.clubName);
    const sport = trimOrUndef(src.sport);
    if (clubName) out.clubName = clubName;
    if (sport) out.sport = sport;

    if (typeof src.createdAt === 'string') {
      out.createdAt = { from: toIso(src.createdAt), to: undefined };
    } else if (src.createdAt && (src.createdAt.from || src.createdAt.to)) {
      out.createdAt = { from: toIso(src.createdAt.from), to: toIso(src.createdAt.to) };
    }
    if (src['schedule.startDate'] && (src['schedule.startDate'].from || src['schedule.startDate'].to)) {
      out['schedule.startDate'] = {
        from: toIso(src['schedule.startDate'].from),
        to: toIso(src['schedule.startDate'].to)
      };
    }

    if (Array.isArray(src.days)) {
      const norm = src.days
        .map((d: string) =>
          String(d)
            .trim()
            .toUpperCase()
        )
        .filter(Boolean);
      if (norm.length) out.days = norm;
    } else if (typeof src.days === 'string') {
      const v = String(src.days)
        .trim()
        .toUpperCase();
      if (v) out.days = [v];
    }

    if (Array.isArray(src.childIdList) && src.childIdList.length) {
      out.childIdList = src.childIdList;
    }

    return out;
  };

  private extractPoint = (obj: any): { type: 'Point'; coordinates: [number, number] } | null => {
    const coords =
      propz.get(obj, ['point', 'coordinates']) ||
      propz.get(obj, ['placeData', 'point', 'coordinates']) ||
      propz.get(obj, ['postcodeData', 'point', 'coordinates']);
    return Array.isArray(coords) && coords.length === 2
      ? { type: 'Point', coordinates: coords as [number, number] }
      : null;
  };

  private fetchPlaceById = async (placeId: string) => {
    const resp = await fetch(`/api/places/${placeId}`, { credentials: 'include' });
    if (!resp.ok) throw new Error(`Place ${placeId} not found`);
    return resp.json();
  };

  private setItems() {
    const { history, user } = this.props;
    const search = parse(history.location.search);

    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '' as TABLE_SORT_DIRECTION;
    let sortFieldName = '';
    if (typeof search.order === 'string') {
      const [field, dir] = (search.order as string).split(':');
      sortFieldName = field || '';
      sortDirection = (dir as TABLE_SORT_DIRECTION) || ('' as TABLE_SORT_DIRECTION);
    }

    const sortByFieldExist = !!sortFieldName;
    const sortDirectionExist = !!sortDirection;

    const rawFilters = getFilters2(FILTER_FIELDS_ALL, search);

    const daysFromUrl = propz.get(search, ['filter'])
      ? (() => {
          try {
            const parsed = JSON.parse(decodeURIComponent(String(search.filter)));
            return Array.isArray(parsed.where?.days) ? parsed.where.days : undefined;
          } catch {
            return undefined;
          }
        })()
      : undefined;

    const likeFromUrl = (key: string): string | undefined => {
      const blob = propz.get(search, ['filter']);
      if (!blob) return undefined;
      try {
        const parsed = JSON.parse(decodeURIComponent(String(blob)));
        const v = parsed?.where?.[key];
        if (!v) return undefined;
        if (typeof v === 'string') return v.trim() || undefined;
        if (typeof v === 'object') {
          return String(v.like ?? v.$regex ?? '').trim() || undefined;
        }
        return undefined;
      } catch {
        return undefined;
      }
    };

    const clubNameFromUrl = likeFromUrl('clubName');
    const sportFromUrl = likeFromUrl('sport');

    const uiFiltersBase = {
      ...rawFilters,
      ...(daysFromUrl ? { days: daysFromUrl } : {}),
      ...(clubNameFromUrl ? { clubName: clubNameFromUrl } : {}),
      ...(sportFromUrl ? { sport: sportFromUrl } : {})
    };

    const filtersForQuery = this.normalizeFiltersForQuery(uiFiltersBase);
    const { createdAt, ...rest } = filtersForQuery;

    const where = {
      kind: 'ClubParticipantInviteMessage',
      ...rest,
      ...(createdAt && (createdAt.from || createdAt.to) ? { createdAt } : {})
    };

    const order = sortByFieldExist && sortDirectionExist ? `${sortFieldName} ${sortDirection}` : undefined;

    const serverQueryFilter = getServerQueryFilter2(page, where, order, CARD_LIMIT);
    const isUnfilteredClubList = Object.keys(where).every(key => key === 'kind');

    const countWhere = { ...where };
    delete countWhere.childIdList;

    const getItemsPromise = getParentInboxMessages(user, serverQueryFilter);
    const getItemsCountPromise = getParentInboxMessagesCount(user, countWhere, true);
    const getChildrenPromise = getChildren(user);
    const getBasketPromise = getBasket(user);

    let children: Child[] = [];

    return BPromise.all([getItemsPromise, getItemsCountPromise, getChildrenPromise, getBasketPromise]).then(
      ([clubBookings, clubBookingsCountObj, _children, basket]) => {
        const visibleClubBookings = clubBookings.filter(item => !this.answeredMessageIds.has(String(item.id)));
        const hiddenAnsweredCount = clubBookings.length - visibleClubBookings.length;
        const hasChildSelection = Array.isArray(uiFiltersBase.childIdList) && uiFiltersBase.childIdList.length > 0;
        const itemCounts = clubBookingsCountObj.itemCounts || {};
        const matchingTotal = hasChildSelection && clubBookingsCountObj.itemCounts
          ? uiFiltersBase.childIdList.reduce((sum, childId) => sum + (itemCounts[String(childId)] || 0), 0)
          : Number(clubBookingsCountObj.count);
        const visibleTotal = Math.max(0, matchingTotal - hiddenAnsweredCount);
        children = (_children || []).map(child => ({ ...child, itemCount: itemCounts[String(child.id)] || 0 }));

        const uiFiltersWithChild = hasChildSelection
          ? uiFiltersBase
          : { ...uiFiltersBase, childIdList: children.map(c => c.id) };

        this.setState(
          {
            items: visibleClubBookings,
            basket,
            currentPage: page,
            children,
            filters: uiFiltersWithChild,
            sortDirection,
            sortFieldName,
            total: visibleTotal,
            basePath: history.location.pathname,
            isLoading: false
          },
          () => {
            getParentClubSectionCounts(user, {
              children,
              ...(isUnfilteredClubList ? { invitations: visibleTotal } : {})
            })
              .then(sectionCounts => this.setState({ sectionCounts }))
              .catch(() => undefined);
          }
        );
      }
    );
  }

  private setCurrentPageParams = (currentPage: number): void => {
    const { filters, sortFieldName, sortDirection } = this.state;
    const parts: string[] = [];

    if (currentPage !== 1) parts.push(`page=${currentPage}`);
    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
  };

  private onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = propz.get(event, ['target', 'value'], '');
    const { filters } = this.state;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, from: filterValue } };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, to: filterValue } };
          break;
      }
    } else {
      const filter = FILTER_FIELDS_ALL.find(col => col.field === filterField);
      const filterType = filter?.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const optionsEl = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < optionsEl.length; i++) {
          if (optionsEl[i].selected) value.push(optionsEl[i].value);
        }
        nextFilters = { ...nextFilters, [filterField]: value };
      } else {
        nextFilters = { ...nextFilters, [filterField]: filterValue };
      }
    }

    this.setState({ filters: nextFilters });
  };

  private toggleDay = (day: string) => {
    const d = day.toUpperCase();

    this.setState(prev => {
      const current: string[] = Array.isArray(prev.filters.days) ? prev.filters.days : [];
      const next = current.includes(d) ? current.filter(value => value !== d) : [...current, d];
      const filters = { ...prev.filters };
      if (next.length) filters.days = next;
      else delete filters.days;
      return { filters };
    });
  };

  private onApplyFilterClick = (): void => {
    const { sortDirection, sortFieldName } = this.state;
    const parts: string[] = [];

    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
  };

  private onClearFilterClick = (): void => {
    this.props.history.push({ pathname: this.state.basePath, search: '' });
  };

  private onChildPickerClick = (childId: string): void => {
    const { children, sortDirection, sortFieldName } = this.state;

    const nextFilters = {
      ...this.state.filters,
      childIdList: childId === 'all' ? children.map(c => c.id) : [childId]
    };

    this.setState({ filters: nextFilters }, () => {
      const parts: string[] = [];
      if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

      const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
      if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

      this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
    });
  };

  private onBookNowClick = (fields: MessageField[], priority: number, submission?: FormSubmission) => {
    const { user, setNeedUpdate } = this.props;
    const { selectedItem } = this.state;

    this.setState({ isLoading: true });

    const data = { fields, priority, ...(submission || {}) };

    const messageId = String(selectedItem!.id);
    acceptParentClubInvitation(user, messageId, data)
      .then(() => {
        this.answeredMessageIds.add(messageId);
        this.setState({ isAcceptModalOpen: false, selectedItem: undefined });
        return this.setItems();
      })
      .then(() => {
        setNeedUpdate();
      });
  };

  private onAddToBasketClick = () => {
    const { user, setNeedUpdate } = this.props;
    const { selectedItem } = this.state;

    this.setState({ isLoading: true });

    const schoolId = propz.get(selectedItem, ['schoolId'], '');
    const studentId = propz.get(selectedItem, ['playerDetailsData', 'id'], '');
    const clubId = propz.get(selectedItem, ['clubId'], '');
    const clubPrice = propz.get(selectedItem, ['clubData', 'price', 'price']);
    const messageId = propz.get(selectedItem, ['id']);

    addOrderToBasket(user, schoolId, clubId, studentId, clubPrice, messageId)
      .then(() => {
        setNeedUpdate();
        return this.setItems();
      })
      .then(() => {
        this.setState({ isAddToBasketProceedModalOpen: true, isAcceptModalOpen: false });
      });
  };

  private onAddToWaitingListClick = () => {
    const { user, setNeedUpdate } = this.props;
    const { selectedItem } = this.state;

    const messageId = String(selectedItem!.id);
    setMessageWaitingStatus(user, messageId).then(() => {
      this.answeredMessageIds.add(messageId);
      this.setState({ isAcceptModalOpen: false, selectedItem: undefined });
      this.setItems().then(() => setNeedUpdate());
    });
  };

  private renderAcceptClubBookingModal = () => {
    const { user } = this.props;
    const { isAcceptModalOpen, selectedItem } = this.state;

    return (
      <SimpleModal
        isOpen={isAcceptModalOpen}
        title="Book this club"
        customClass="parentCompactModal"
        onCloseClick={this.closeAcceptClubBookingModal}
        showFooter={false}
      >
        <ClubInvitationForm
          user={user}
          message={selectedItem}
          onBookNowClick={this.onBookNowClick}
          onAddToBasketClick={this.onAddToBasketClick}
          onAddToWaitingListClick={this.onAddToWaitingListClick}
          closeClubInvitationModal={this.closeAcceptClubBookingModal}
          onDeclineClick={this.openDeclineFromAcceptModal}
        />
      </SimpleModal>
    );
  };

  private openAcceptClubBookingModal = message => {
    this.setState({ isAcceptModalOpen: true, selectedItem: message });
  };
  private closeAcceptClubBookingModal = () => {
    this.setState({ isAcceptModalOpen: false, selectedItem: undefined });
  };

  private openDeclineFromAcceptModal = () => {
    this.setState({ isAcceptModalOpen: false, isDeclineModalOpen: true });
  };

  private onGoToBasketClick = () => {
    this.props.history.push({ pathname: `/basket` });
  };

  private renderAddToBasketProceedModal = () => {
    const { isAddToBasketProceedModalOpen, basket } = this.state;
    const orderAmount = propz.get(basket, ['orderAmount'], 0);
    const items = propz.get(basket, ['items'], []);
    const basketOrdersCount = Array.isArray(items) ? items.length : 0;

    return (
      <SimpleModal
        isOpen={isAddToBasketProceedModalOpen}
        title={`Basket Subtotal: £${orderAmount}`}
        body="Please select how you would like to proceed."
        customClass="modal-lg"
      >
        <div className="d-flex flex-wrap mt-4">
          <Button customClass="mr-2" text={`Proceed to checkout ${basketOrdersCount} item(s)`} onClick={() => {}} />
          <Button customClass="mr-2" text="Go to basket" onClick={this.onGoToBasketClick} />
          <Button text="Continue booking" onClick={this.closeAddToBasketProceedModal} />
        </div>
      </SimpleModal>
    );
  };
  private openAddToBasketProceedModal = () => this.setState({ isAddToBasketProceedModalOpen: true });
  private closeAddToBasketProceedModal = () =>
    this.setState({ isAddToBasketProceedModalOpen: false, selectedItem: undefined });

  private onDeclineClubBookingClick = () => {
    const { user, setNeedUpdate } = this.props;
    const { selectedItem } = this.state;

    this.setState({ isLoading: true });

    const messageId = String(selectedItem!.id);
    rejectParentClubInvitation(user, messageId).then(() => {
      this.answeredMessageIds.add(messageId);
      this.setState({ isDeclineModalOpen: false, selectedItem: undefined });
      this.setItems().then(() => {
        setNeedUpdate();
      });
    });
  };

  private openDeclineClubBookingModal = message => this.setState({ isDeclineModalOpen: true, selectedItem: message });
  private closeDeclineClubBookingModal = () => this.setState({ isDeclineModalOpen: false, selectedItem: undefined });

  private renderDeclineClubBookingModal = () => {
    const { isDeclineModalOpen, selectedItem } = this.state;
    if (!selectedItem) return null;

    const studentName = getFullName(propz.get(selectedItem, ['playerDetailsData'], {}));
    const clubName = propz.get(selectedItem, ['clubData', 'name'], '');

    const placeName = propz.get(selectedItem, ['clubData', 'venue', 'placeData', 'name'], '');
    const postcodeA = propz.get(selectedItem, ['clubData', 'venue', 'placeData', 'postcode'], '');
    const postcodeB = propz.get(selectedItem, ['clubData', 'venue', 'postcodeData', 'postcode'], '');
    const postcode = postcodeA || postcodeB || '';
    const venue = [placeName, postcode].filter(Boolean).join(', ');

    const startDate = propz.get(selectedItem, ['clubData', 'startDate']);
    const finishDate = propz.get(selectedItem, ['clubData', 'finishDate']);
    const runStart = startDate ? moment(startDate).format('D MMM YYYY') : '';
    const runEnd = finishDate ? moment(finishDate).format('D MMM YYYY') : '';
    const sameDay = startDate && finishDate && moment(startDate).isSame(finishDate, 'day');
    const runText = runStart ? (sameDay ? runStart : runEnd ? `${runStart} - ${runEnd}` : runStart) : runEnd || '';

    const days = propz.get(selectedItem, ['clubData', 'days'], []);
    const daysText =
      Array.isArray(days) && days.length ? days.map(d => WEEK_DAYS_SERVER_TO_CLIENT_MAPPING[d] || d).join(', ') : '';

    const timeISO = propz.get(selectedItem, ['clubData', 'time']);
    const durationMin = propz.get(selectedItem, ['clubData', 'duration'], 0);
    const startMs = timeISO ? new Date(timeISO).getTime() : undefined;
    const endISO = typeof startMs === 'number' ? new Date(startMs + durationMin * 60 * 1000).toISOString() : undefined;

    const timeRangeStr = timeISO
      ? `${moment(timeISO).format('HH:mm')}${endISO ? `–${moment(endISO).format('HH:mm')}` : ''}`
      : '';

    const whenText = [daysText, timeRangeStr].filter(Boolean).join(' • ');

    return (
      <SimpleModal
        isOpen={isDeclineModalOpen}
        onCloseClick={this.closeDeclineClubBookingModal}
        showFooter={false}
        customClass="DeclineModal"
        title="Confirm decline"
      >
        <div className="DeclineModal__header">
          <div className="DeclineModal__icon" aria-hidden>
            ⚠️
          </div>
          <div className="DeclineModal__titles">
            <h3>Decline this booking?</h3>
            <p>
              If you decline, the organiser will be notified that <strong>{studentName}</strong> won’t attend{' '}
              <strong>{clubName}</strong>.
            </p>
          </div>
        </div>

        <div className="DeclineModal__summary">
          <div className="DeclineModal__row">
            <span className="label">Club</span>
            <span className="value">{clubName || '—'}</span>
          </div>

          {runText && (
            <div className="DeclineModal__row">
              <span className="label">Run</span>
              <span className="value">{runText}</span>
            </div>
          )}

          {whenText && (
            <div className="DeclineModal__row">
              <span className="label">When</span>
              <span className="value">{whenText}</span>
            </div>
          )}

          {venue && (
            <div className="DeclineModal__row">
              <span className="label">Where</span>
              <span className="value">{venue}</span>
            </div>
          )}
        </div>

        <div className="DeclineModal__cta">
          <button className="btn btn-light" onClick={this.closeDeclineClubBookingModal}>
            Go back
          </button>
          <button className="btn btn-respond btn-decline" onClick={this.onDeclineClubBookingClick}>
            Decline invitation
          </button>
        </div>
      </SimpleModal>
    );
  };

  private renderViewMapModal = () => {
    const { isViewMapModalOpen, selectedItem, mapPoint, mapLabel } = this.state;

    const pointFromItem = propz.get(selectedItem, ['clubData', 'venue', 'placeData', 'point']);

    const point = mapPoint ?? pointFromItem ?? null;
    const label =
      mapLabel ||
      propz.get(selectedItem, ['clubData', 'venue', 'placeData', 'name']) ||
      propz.get(selectedItem, ['clubData', 'venue', 'placeName']) ||
      'Venue';

    return (
      <SimpleModal isOpen={isViewMapModalOpen} onCloseClick={this.closeViewMapModal} title="View map">
        <Map point={point} customStylingClass="eChildEventVenueMap" isMarkerDraggable={false} />
      </SimpleModal>
    );
  };

  private openViewMapModal = async (message: EventInvitationMessage) => {
    const venue = propz.get(message, ['clubData', 'venue'], {});
    let point = this.extractPoint(venue);
    let label = propz.get(venue, ['placeData', 'name']) || propz.get(venue, ['placeName']) || '';

    if (!point) {
      const placeId = propz.get(venue, ['placeId']);
      if (placeId) {
        try {
          const place = await this.fetchPlaceById(placeId);
          const resolved = this.extractPoint(place);
          if (resolved) {
            point = resolved;
            label = propz.get(place, ['placeData', 'name']) || propz.get(place, ['name']) || label || '';
          }
        } catch (e) {}
      }
    }

    this.setState({
      isViewMapModalOpen: true,
      selectedItem: message,
      mapPoint: point ?? null,
      mapLabel: label || undefined
    });
  };

  private closeViewMapModal = () => this.setState({ isViewMapModalOpen: false, selectedItem: undefined });

  private renderShowDetailsModal = () => {
    const { isShowDetailsModalOpen, selectedItem } = this.state;
    return (
      <SimpleModal
        isOpen={isShowDetailsModalOpen}
        onCloseClick={this.closeShowDetailsModal}
        title="Club details"
        side="right"
        showFooter={false}
      >
        <ClubBookingDeatils message={selectedItem} />
      </SimpleModal>
    );
  };
  private openShowDetailsModal = message => this.setState({ isShowDetailsModalOpen: true, selectedItem: message });
  private closeShowDetailsModal = () => this.setState({ isShowDetailsModalOpen: false, selectedItem: undefined });

  render() {
    const { isLoading, isFiltersOpen, total, currentPage, items, filters, children, sectionCounts } = this.state;

    if (isLoading) return <Loader />;

    const childIdList = children.map(child => child.id);
    const selectedChildIds =
      filters.childIdList && filters.childIdList.length ? filters.childIdList : children.map(c => c.id);

    const selectedDays: string[] = Array.isArray(filters.days) ? filters.days : [];

    return (
      <main className="parentPage parentListPage parentClubsPage">
        {this.renderAddToBasketProceedModal()}
        {this.renderDeclineClubBookingModal()}
        {this.renderAcceptClubBookingModal()}
        {this.renderViewMapModal()}
        {this.renderShowDetailsModal()}

        <ParentPageHeader
          title="Clubs"
          tabs={clubSectionTabs(sectionCounts, 'invitations', this.props.history)}
          chips={[
            {
              value: total,
              label: total === 1 ? 'invitation awaiting response' : 'invitations awaiting response',
              tone: total ? 'amber' : 'green'
            }
          ]}
        />

        <ItemsBar
          items={children}
          itemIdList={selectedChildIds}
          onClick={this.onChildPickerClick}
          allItemsTitle="All children"
          getItemName={(c: any) => `${c.firstName} ${c.lastName}`}
        />

        <div className="parentListControls">
          <div className="parentListSearch">
            <input
              type="search"
              className="form-control"
              aria-label="Search by club name"
              placeholder="Search club name…"
              value={filters.clubName || ''}
              onChange={e => this.onTableFilterChange(e, 'clubName')}
              onKeyDown={e => {
                if (e.key === 'Enter') this.onApplyFilterClick();
              }}
            />
          </div>
          <button
            className={isFiltersOpen ? 'parentFilterButton is-active' : 'parentFilterButton'}
            onClick={() => this.setState(prev => ({ isFiltersOpen: !prev.isFiltersOpen }))}
          >
            <span className="parentFilterButton__icon" aria-hidden="true" /> Filters
          </button>

          <Pagination2
            currentPage={currentPage}
            total={total}
            setCurrentPageParams={this.setCurrentPageParams}
            limit={CARD_LIMIT}
            modern
          />
        </div>
        <AppliedTextFilterChip
          history={this.props.history}
          location={this.props.location}
          filters={[
            { filterKey: 'clubName', label: 'Club name' },
            { filterKey: 'sport', label: 'Activity/Sport' },
            { filterKey: 'createdAt', label: 'Invitation date', type: 'date' },
            { filterKey: 'schedule.startDate', label: 'Club start date', type: 'date' },
            {
              filterKey: 'days',
              label: 'Days',
              type: 'multi',
              valueLabels: {
                MONDAY: 'Monday', TUESDAY: 'Tuesday', WEDNESDAY: 'Wednesday', THURSDAY: 'Thursday',
                FRIDAY: 'Friday', SATURDAY: 'Saturday', SUNDAY: 'Sunday'
              }
            }
          ]}
        />

        {isFiltersOpen && (
          <div className="parentFilterSurface">
            <ParentFilterBar
              filters={filters}
              showTextFilter={false}
              onTableFilterChange={this.onTableFilterChange}
              onApply={this.onApplyFilterClick}
              onClear={this.onClearFilterClick}
              onCancel={() => this.setState({ isFiltersOpen: false })}
              labels={{
                text: 'Club name',
                secondText: 'Activity/Sport',
                date: 'Invitation date',
                secondDate: 'Club start date'
              }}
              fieldKeys={{
                textKey: 'clubName',
                secondTextKey: 'sport',
                dateKey: 'createdAt',
                secondDateKey: 'schedule.startDate'
              }}
              extraFilters={
                <div className="parentFilterDrawer__field">
                  <label className="form-label">Days of week</label>
                  <div className="parentFilterDrawer__chips">
                    {ALL_DAYS.map(day => (
                      <button
                        key={day}
                        type="button"
                        className={selectedDays.includes(day) ? 'is-selected' : ''}
                        onClick={() => this.toggleDay(day)}
                      >
                        {day.charAt(0) + day.slice(1).toLowerCase()}
                      </button>
                    ))}
                  </div>
                </div>
              }
            />
          </div>
        )}
        {items.length === 0 ? (
          <div className="parentListEmpty">
            <strong>{hasClubSectionContent(sectionCounts) ? 'No club invitations' : 'Nothing here yet'}</strong>
            <span>
              {hasClubSectionContent(sectionCounts)
                ? 'There are no invitations matching the selected children and filters.'
                : 'When your school sends or opens something, you will see it here.'}
            </span>
          </div>
        ) : (
          <div className="parentListGrid">
            {items.map(item => {
              const { id } = item;
              return (
                <div className="parentListGrid__item" key={id}>
                  <ClubBookingCard
                    user={this.props.user}
                    item={item}
                    type={INVITE_TYPE.INBOX}
                    onDeclineClick={this.openDeclineClubBookingModal}
                    onBookClick={this.openAcceptClubBookingModal}
                    onViewMapClick={this.openViewMapModal}
                    onShowDetailsClick={this.openShowDetailsModal}
                  />
                </div>
              );
            })}
          </div>
        )}
      </main>
    );
  }
}
